<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">积分说明</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/更换.png" class="nav-img none" />
      </div>
    </div>

    <div>
      <div class="item">
        <p class="question"><span class="tag"></span>积分是什么？</p>
        <div class="answer">积分是小火柴平台内用户收益的计算标准。积分可以直接提现，积分越高收益越高。</div>
      </div>

      <div class="item">
        <p class="question"><span class="tag"></span>积分能干什么？</p>
        <div class="answer">积分可以直接提现，目前的兑换比例为 1000:1，即为1000积分可以兑换1元。</div>
      </div>

      <div class="item">
        <p class="question"><span class="tag"></span>如何获取积分？</p>
        <div class="answer">
          积分的获取方式有很多种:
          <p class="answer-item">1.加好友，聊天过程中，对方申请添加你为好友，同意即可获得积分。</p>
          <p class="answer-item mg-top">2.收到礼物，对方给你赠送礼物时会根据一定比例兑换成积分。</p>
          <p class="answer-item mg-top">3.微信号被查看，你的微信号被用户查看即可获得积分。</p>
          <p class="answer-item mg-top">4.每日签到，每日签到可获得随机积分奖励。</p>
          <p class="answer-item mg-top">5.其他方式，平台后期开放。</p>
        </div>
      </div>

      <div class="item">
          <p class="question"><span class="tag"></span>在哪里提现？</p>
          <div class="answer">提现位置：我的 --> 我的钱包 --> 提现。</div>
        </div>

    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
  export default {
    data() {
      return {
        theme_dark: false
      };
    },

    methods: {
      back() {
        this.$router.go(-1); //返回上一层
      }
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
    }
  };
</script>

<style lang="scss" scoped>
  .item {
    padding: 0.5rem;
    .question {
      margin: 0;
      color: #000;
      font-weight: 600;
      .tag {
        display: inline-block;
        width: 0.2rem;
        height: 0.9rem;
        background-color: #e92162;
        margin-right: 0.2rem;
      }
    }
    .answer {
        font-size: 0.8rem;
        color: #565656;
        line-height: 1.6rem;
        margin-top: 0.5rem;
        .answer-item {
          margin: 0;
          padding: 0;
        }
        .mg-top {
            margin-top: .5rem;
        }
      }
  }

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .question {
    color: #FDFDFD;
  }
  .answer {
    color: #888;
  }
}
</style>